import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredOrderVoidAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderVoid',
  (params: { id: string }) => ({
    tradeBrokeredOrderVoid: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
